import { render, staticRenderFns } from "./tickets_table.vue?vue&type=template&id=150d4110&scoped=true"
import script from "./tickets_table.vue?vue&type=script&lang=js"
export * from "./tickets_table.vue?vue&type=script&lang=js"
import style0 from "./tickets_table.vue?vue&type=style&index=0&id=150d4110&prod&lang=css"
import style1 from "./tickets_table.vue?vue&type=style&index=1&id=150d4110&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150d4110",
  null
  
)

export default component.exports